import { Controller, FormProvider, useForm } from "react-hook-form";
import TextInput from "shared/ui/TextInput";
import { requiredRules } from "shared/helpers/validators";
import ButtonLoader from "shared/ui/ButtonLoader";
import { Box, Switch, Tooltip, Typography } from "@mui/material";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import { TestCustomersCampaign } from "store/slicers/campaigns";
import { useSelector } from "react-redux";
import { selectCampaignInfo } from "store/slicers/campaignDetail";
import { ERequestStatus } from "store/enums/index.enum";
import toast from "react-hot-toast";
import useTranslation from "shared/helpers/hooks/useTranslation";
import { EDistributionMethods } from "store/enums/campaignDetails";

const TestSMSForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const t = useTranslation();
  const campaignInfo = useSelector(selectCampaignInfo);
  const dispatch = useAsyncDispatch();
  const methods = useForm({
    defaultValues: {
      phone: "",
      ignoreQuarantine: false,
    },
  });

  const onSubmit = async (formData) => {
    const { meta } = await dispatch(
      TestCustomersCampaign({
        phoneNumbers: formData.phone.split(",").map((item) => item.trim()),
        campaignID: campaignInfo.id,
        ignoreQuarantine: formData.ignoreQuarantine,
        distributionMethod: EDistributionMethods.SMS,
      })
    );
    if (meta.requestStatus !== ERequestStatus.FULFILLED) {
      return;
    }

    toast.success("Test SMS sended");
    onSuccess?.();
  };

  return (
    <FormProvider {...methods}>
      <Box mb={2}>
        <Tooltip
          title={
            "Phone number must be filled in with its country code. This field can contain multiple numbers separated with comma."
          }
        >
          <Typography>Phone numbers</Typography>
        </Tooltip>
      </Box>
      <TextInput
        name="phone"
        label="Recipient phone number"
        placeholder="37400000000, 37499999999"
        rules={requiredRules}
      />
      <Box
        display="flex"
        justifyContent={"space-between"}
        alignItems={"stretch"}
        mb={2}
        mt={2}
      >
        <Box display="flex" alignItems="center">
          <Typography>{t("include_the_quarantined_customers")}</Typography>
        </Box>
        <Box flex={1}>
          <Controller
            name="ignoreQuarantine"
            control={methods.control}
            render={({ field }) => (
              <Tooltip
                placement="top-start"
                title={
                  "In case activation of this function the survey will be sent the quarantined customers as well after receiving the trigger."
                }
              >
                <Switch color="success" {...field} checked={field.value} />
              </Tooltip>
            )}
          />
        </Box>
      </Box>
      <Box display="flex" flexDirection={"row-reverse"} mt={2}>
        <ButtonLoader
          isLoading={false}
          onClick={methods.handleSubmit(onSubmit)}
        >
          <Typography>Test</Typography>
        </ButtonLoader>
      </Box>
    </FormProvider>
  );
};

export default TestSMSForm;
